import { render, staticRenderFns } from "./BusinessSignUpBlock.vue?vue&type=template&id=d5002400&scoped=true&"
import script from "./BusinessSignUpBlock.vue?vue&type=script&lang=js&"
export * from "./BusinessSignUpBlock.vue?vue&type=script&lang=js&"
import style0 from "./BusinessSignUpBlock.vue?vue&type=style&index=0&id=d5002400&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5002400",
  null
  
)

export default component.exports